import { UserType } from "data/types";

export const isProfileCompleted = () => {
    const userData = localStorage.getItem("user");
    let user: UserType;
    if (userData) {
        user = JSON.parse(userData) as UserType;
        if (user?.username && (user.username !== '' || user.phone !== '' || user.ci !== '')) {
            return true;
        } else {
            return false;
        }
    }
}